require('./accountChequesMovementsTableRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { OKLink } = require('commonsComponents/OKLink');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ constants
const {
    HYPHEN,
    ACCOUNT_CHEQUEBOOK_DETERIORATED,
    ACCOUNT_CHEQUEBOOK_MISSING,
    ACCOUNT_CHEQUEBOOK_STOLEN,
    ACCOUNT_CHEQUEBOOK_VALID
} = require('constants/index');

class AccountChequesMovementsTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getStatusTranslation(status) {
        switch (status) {
            case ACCOUNT_CHEQUEBOOK_DETERIORATED:
                return formatText('accountCheques-chequebookDeteriorated');
            case ACCOUNT_CHEQUEBOOK_MISSING:
                return formatText('accountCheques-chequebookMissing');
            case ACCOUNT_CHEQUEBOOK_STOLEN:
                return formatText('accountCheques-chequebookStolen');
            case ACCOUNT_CHEQUEBOOK_VALID:
                return formatText('accountCheques-chequebookValid');
            default:
                return status;
        }
    }

    getTextAccordingToCount(count) {
        return count === 0 ? '' : count === 1 ? formatText('accountCheques-cheque').toLowerCase() : formatText('accountCheques-cheques').toLowerCase();
    }

    render() {
        const { immTransaction, id, originalIndex, isCanceledAccount } = this.props;

        const accountId = immTransaction.get('accountId');

        const pendingCount = immTransaction.get('pendingCount');
        const payedCount =immTransaction.get('payedCount');
        const irregularCount =immTransaction.get('irregularCount');

        const usedChequesLink = `/myprofile/accounts/${accountId}/chequebook/${originalIndex}`;
        const usedCheques = formatText('accountCheques-usedCheques');

        const status = immTransaction.get('status').trim();
        const statusText = this.getStatusTranslation(status);

        let cancelCheques, cancelChequebooks;

        if (status === ACCOUNT_CHEQUEBOOK_VALID) {
            const cancelChequesLink = `/myprofile/accounts/${accountId}/cheques/cancel-cheque/${originalIndex}`;
            const cancelChequebookLink = `/myprofile/accounts/${accountId}/cheques/cancel-chequebook/${originalIndex}`;

            cancelCheques = (
                <OKButton
                    id={`lnkEnableCancelCheques${originalIndex}`}
                    modifier="ghost"
                    to={cancelChequesLink}
                >
                    <FormattedText value="accountCheques-cancelCheques" />
                </OKButton>
            );

            cancelChequebooks = (
                <OKButton
                    id={`lnkEnableCancelChequebook${originalIndex}`}
                    modifier="secondary"
                    to={cancelChequebookLink}
                >
                    <FormattedText value="accountCheques-cancelChequebook" />
                </OKButton>
            );
        } else {
            cancelCheques = (
                <OKButton id={`lnkEnableCancelCheques${originalIndex}`} modifier="ghost" disabled={true}>
                    <FormattedText value="accountCheques-cancelCheques" />
                </OKButton>
            );

            const accountChequesClassName = contactCenterClassName('account-cheques-movements-table-row__cancelled-button-label')
            const cancelChequebooksButton = (
                <div className="account-cheques-movements-table-row__cancelled-button">
                    <OKButton id={`lnkDisableCancelChequebook${originalIndex}`} disabled={true} block={true}>
                        <FormattedText
                            value="accountCheques-chequebookCanceled"
                            className={accountChequesClassName}
                        />
                    </OKButton>
                </div>
            );

            cancelChequebooks = (
                <OKTooltip
                    content="accountCheques-tooltip"
                    offset={[0, -10]}
                    target={cancelChequebooksButton}
                />
            );
        }

        if(__CONTACT_CENTER__ && isCanceledAccount) {
            cancelCheques = null;
            cancelChequebooks = null;
        }

        return (
            <OKTableRow className="account-cheques-movements-table-row" id={id}>
                <OKTableCell className="">
                    {statusText}
                </OKTableCell>
                <OKTableCell className="account-cheques-movements-table-row__cell-id">
                    {immTransaction.get('initialNum')} {HYPHEN} {immTransaction.get('finalNum')}
                </OKTableCell>
                <OKTableCell className="account-cheques-movements-table-row__cell-pending">
                    {pendingCount}
                </OKTableCell>
                <OKTableCell className="account-cheques-movements-table-row__cell-payed">
                    {payedCount}
                </OKTableCell>
                <OKTableCell className="account-cheques-movements-table-row__cell-irregular">
                    {irregularCount}
                </OKTableCell>
                <OKTableCell className="row account-cheques-movements-table-row__cheques-actions-row">
                    <div className="col-xs-12 col-lg-4 account-cheques-movements-table-row__cheques-actions-element">
                        <OKLink id={`lnkUsedCheques${originalIndex}`} modifier="complementary" to={usedChequesLink}>
                            {usedCheques}
                        </OKLink>
                    </div>
                    <div className="col-xs-12 col-lg-4 account-cheques-movements-table-row__cheques-actions-element">
                        {cancelCheques}
                    </div>
                    <div className="col-xs-12 col-lg-4 account-cheques-movements-table-row__cheques-actions-element">
                        {cancelChequebooks}
                    </div>
                </OKTableCell>
            </OKTableRow>
        );
    }
}

AccountChequesMovementsTableRow.propTypes = {
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    originalIndex: PropTypes.number,
    isCanceledAccount: PropTypes.bool
}

AccountChequesMovementsTableRow.defaultProps = {
    isCanceledAccount: false
}

module.exports = AccountChequesMovementsTableRow;
